import { authFetch } from '@/utils/auth-fetch';

export interface AttributionProduct {
  product_url: string;
  completed_at: string;
  clicks_before_7d: number;
  clicks_after_7d: number;
  clicks_delta_pct: number | null;
  position_before: number | null;
  position_after: number | null;
  position_delta: number | null;
  impressions_before_7d: number;
  impressions_after_7d: number;
}

export interface AttributionResponse {
  products: AttributionProduct[];
  total: number;
  has_empty_state: boolean;
}

export async function fetchAttribution(
  siteId: string,
  limit = 50,
  offset = 0,
): Promise<AttributionResponse> {
  const params = new URLSearchParams({ site_id: siteId, limit: String(limit), offset: String(offset) });
  const res = await authFetch(`/api/impact/shopify/attribution?${params}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  const data: AttributionResponse = await res.json();
  // Postgres returns numeric columns as strings — coerce to number so .toFixed() works.
  data.products = data.products.map(p => ({
    ...p,
    clicks_before_7d: Number(p.clicks_before_7d),
    clicks_after_7d: Number(p.clicks_after_7d),
    clicks_delta_pct: p.clicks_delta_pct != null ? Number(p.clicks_delta_pct) : null,
    position_before: p.position_before != null ? Number(p.position_before) : null,
    position_after: p.position_after != null ? Number(p.position_after) : null,
    position_delta: p.position_delta != null ? Number(p.position_delta) : null,
    impressions_before_7d: Number(p.impressions_before_7d),
    impressions_after_7d: Number(p.impressions_after_7d),
  }));
  return data;
}
